import styles from "./FamilyWizard.module.scss";
import { nameof } from "ts-simple-nameof";
import { HiddenField } from "../../../../common/components/forms/inputs/hiddenField/HiddenField";
import { PageMode } from "../../../../common/types";
import { IFamilyWizardFormModel } from "./models/familyWizardFormModel";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultFormMultiSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormMultiSelectField";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { useFamilyWizardPage } from "./hooks/useFamilyWizardPage";
import { FormProvider } from "react-hook-form";
import { SingleSectionPageLayout } from "../../../../common/components/common/SingleSectionPageLayout";
import { useAppContext } from "../../../../AppContext";
import { DefaultFormSelectField } from "../../../../common/components/forms/inputs/dropdown/DefaultFormSelectField";

interface IFamilyWizardProps {
  pageMode: PageMode;
}

export const FamilyWizard = ({ pageMode }: IFamilyWizardProps) => {
  const {
    form,
    pageTitle,
    actionButtonLabel,
    users,
    selectedUsers,
    handleSubmit,
  } = useFamilyWizardPage(pageMode);

  const { isDesktopOrTablet } = useAppContext();

  const children = (
    <>
      <div className={styles.root_fields}>
        <HiddenField name={nameof<IFamilyWizardFormModel>((x) => x.id)} />
        <HiddenField name={nameof<IFamilyWizardFormModel>((x) => x.studioId)} />

        <DefaultInputField
          name={nameof<IFamilyWizardFormModel>((x) => x.name)}
          label="Име"
          placeholder="Георгиеви"
          width={isDesktopOrTablet ? "600px" : "80%"}
          required
        />

        <DefaultFormMultiSelectField
          name={nameof<IFamilyWizardFormModel>((x) => x.members)}
          label="Потребители"
          options={users}
          required
          virtualScrollerOptions={{ itemSize: 43 }}
        />

        <DefaultFormSelectField
          name={nameof<IFamilyWizardFormModel>((x) => x.headOfFamily)}
          label="Отговорник на семейството"
          tooltip="Отговорникът на семейството може да прави резервации от името на всеки член на семейството."
          options={selectedUsers}
        />
      </div>
      <div className={styles.root_buttons}>
        <DefaultButton label={actionButtonLabel} type="submit" />
      </div>
    </>
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)}>
        <SingleSectionPageLayout
          title={pageTitle}
          maxHeight={"85%"}
          children={children}
        />
      </form>
    </FormProvider>
  );
};
